import { Box, Card, Grid, Stack, Typography } from "@mui/material"
import { GetPublicClaimDetailResponse } from "../../../client/motalvip-apis/generated"
import dayjs from "dayjs"
import { PreviewImage } from "../../common/PreviewImage"
import { LockTypeNameMapping } from "../constants"

interface Props {
    claimDetail: GetPublicClaimDetailResponse
}

export const ClaimDetailCard = ({ claimDetail }: Props) => {
    const displayImei = claimDetail.imei
        ? claimDetail.imei.length > 5
            ? claimDetail.imei.slice(0, claimDetail.imei.length - 5) + '*****'
            : '*'.repeat(claimDetail.imei.length)
        : '-'

    return (
        <Card sx={{ padding: { xs: "16px", md: "38px" }, flex: 1 }}>
            <Stack direction='column' spacing="24px" alignItems="flex-start">
                <Typography fontSize={{ xs: "16px", md: "22px" }} fontWeight={400} color="#292929">รายละเอียดงานซ่อม</Typography>
                <Grid container>
                    <Grid item xs={6} md={4}>
                        <Stack direction="column" gap="24px" alignItems="flex-start">
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">เลขที่สัญญา</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">วันที่นำเข้า</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">วันที่นัดหมายลูกค้า</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">รายละเอียดปัญหา</Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={6} md={8} pl="8px">
                        <Stack direction="column" gap="24px" alignItems="flex-start">
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{claimDetail.claimNo}</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{dayjs(claimDetail.importedAt).format('DD/MM/YYYY')}</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{dayjs(claimDetail.appointmentAt).format('DD/MM/YYYY')}</Typography>
                            <Stack direction="column" gap="8px" alignItems="flex-start">
                                {claimDetail.items?.map((item, index) => (
                                    <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{index + 1}. {item.problemDetails}</Typography>
                                ))}
                            </Stack>
                        </Stack>
                    </Grid>
                </Grid>
                <Stack direction="column" gap="4px" alignItems="flex-start">
                    <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">ไฟล์แนบ</Typography>
                    <Stack direction="row" gap="24px" flexWrap="wrap">
                        {claimDetail.images?.map((image, index) => (
                            <Box sx={{ width: { xs: "60px", md: "120px" }, height: { xs: "60px", md: "120px" } }}>
                                <PreviewImage key={index} src={image.imageUrl} />
                            </Box>
                        ))}
                    </Stack>
                </Stack>
                <Grid container>
                    <Grid item xs={6} md={4}>
                        <Stack direction="column" gap="24px" alignItems="flex-start">
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">แบรนด์</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">รุ่นเครื่อง</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">IMEI</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">Serial Number</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">เปอร์เซ็นต์แบตเตอรี่</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">ประเภทรหัสปลดล็อกเครื่อง</Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={6} md={8} pl="8px">
                        <Stack direction="column" gap="24px" alignItems="flex-start">
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{claimDetail.brand}</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{claimDetail.version}</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{displayImei}</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{claimDetail.serialNumber || '-'}</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{claimDetail.battery ? `${claimDetail.battery}%` : '-'}</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{LockTypeNameMapping[claimDetail.lockType || GetPublicClaimDetailResponse.lockType.NONE]}</Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </Stack>
            <Stack direction="column" gap="12px" alignItems="flex-start" mt="40px">
                <Typography fontSize={{ xs: "16px", md: "22px" }} fontWeight={400} color="#292929">ข้อมูลร้านค้าที่รับซ่อม</Typography>
                <Grid container>
                    <Grid item xs={6} md={4}>
                        <Stack direction="column" gap="12px" alignItems="flex-start">
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">ชื่อร้าน</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">เบอร์โทรศัพท์</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#292929">ที่อยู่</Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={6} md={8} pl="8px">
                        <Stack direction="column" gap="12px" alignItems="flex-start">
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{claimDetail.shop?.name}</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{claimDetail.shop?.phoneNumber || '-'}</Typography>
                            <Typography fontSize={{ xs: "14px", md: "16px" }} fontWeight={400} color="#6F6F6F">{claimDetail.shop?.address || '-'}</Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </Stack>
        </Card>
    )
}